import { StyleSheet } from 'aphrodite'
import { media } from 'consts'

const styles = StyleSheet.create({
  mediaWrapper: {
    height: '100%',
    display: 'flex',
    transition: '500ms ease-out'
  },
  contentWrapper: {
    flex: '1 1 auto',
    position: 'relative'
  },
  breadcrumbPositioner: {
    flex: '1 1 auto',
    marginTop: media.breadcrumb.dimensions.margin.top,
    marginBottom: media.breadcrumb.dimensions.margin.bottom,
    marginRight: media.breadcrumb.dimensions.margin.right,
    marginLeft: media.breadcrumb.dimensions.margin.left
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/components/Media/styles.js